export const data = [
  //////////////////
  // ATTACK ON TITAN
  //////////////////
  {
    id: 1,
    title: "Attack on Titan: Basic Scouts Hoodie",
    price: 40,
    image: "/images/merch/Attack-on-Titan/aot-hoodie.jpg",
    clothing: true,
  },
  {
    id: 2,
    title: "Attack on Titan: Scout Flower Hoodie",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-2.jpg",
    clothing: true,
  },
  {
    id: 3,
    title: "Attack on Titan: Scout Split Hoodie",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-3.jpg",
    clothing: true,
  },
  {
    id: 4,
    title: "Attack on Titan: Levi Hoodie",
    price: 40,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-4.jpg",
    clothing: true,
  },
  {
    id: 5,
    title: "Attack on Titan: Levi Eyes Hoodie",
    price: 35,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-5.jpg",
    clothing: true,
  },
  {
    id: 6,
    title: "Attack on Titan: Levi Side Eyes Hoodie",
    price: 35,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-6.jpg",
    clothing: true,
  },
  {
    id: 7,
    title: "Attack on Titan: Scout Full Zip Hoodie",
    price: 45,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-7.jpg",
    clothing: true,
  },
  {
    id: 8,
    title: "Attack on Titan: Eren Titan Hoodie",
    price: 35,
    image: "/images/merch/Attack-on-Titan/aot-hoodie-8.jpg",
    clothing: true,
  },
  {
    id: 9,
    title: "Attack on Titan: Scout Letterman Jacket",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket.jpg",
    clothing: true,
  },
  {
    id: 10,
    title: "Attack on Titan: Scout Ugly Christmas Sweater",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 11,
    title: "Attack on Titan: Garrison Ugly Christmas Sweater",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 12,
    title: "Attack on Titan: Military Police Ugly Christmas Sweater",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 13,
    title: "Attack on Titan: Scout Bomber Jacket",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 14,
    title: "Attack on Titan: Garrison Bomber Jacket",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 15,
    title: "Attack on Titan: Military Police Bomber Jacket",
    price: 60,
    image: "/images/merch/Attack-on-Titan/aot-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 16,
    title: "Attack on Titan: Scout Cloak",
    price: 80,
    image: "/images/merch/Attack-on-Titan/aot-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 17,
    title: "Attack on Titan: Scout Patch Crewneck",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 18,
    title: "Attack on Titan: Mikasa T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt.jpg",
    clothing: true,
  },
  {
    id: 19,
    title: "Attack on Titan: Levi Side Eyes T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 20,
    title: "Attack on Titan: Scout T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 21,
    title: "Attack on Titan: Levi Red and Blue T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 22,
    title: "Attack on Titan: Scout Patch T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 23,
    title: "Attack on Titan: Titan T-Shirt",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 24,
    title: "Attack on Titan: Mikasa Poster",
    price: 15,
    image: "/images/merch/Attack-on-Titan/aot-poster.jpg",
    clothing: false,
  },
  {
    id: 25,
    title: "Attack on Titan: Scout Poster",
    price: 15,
    image: "/images/merch/Attack-on-Titan/aot-poster-2.jpg",
    clothing: false,
  },
  {
    id: 26,
    title: "Attack on Titan: Levi Scout Poster",
    price: 15,
    image: "/images/merch/Attack-on-Titan/aot-poster-3.jpg",
    clothing: false,
  },
  {
    id: 27,
    title: "Attack on Titan: Scout Tapestry",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-poster-4.jpg",
    clothing: false,
  },
  {
    id: 28,
    title: "Attack on Titan: Eren and Titans Tapestry",
    price: 25,
    image: "/images/merch/Attack-on-Titan/aot-poster-5.jpg",
    clothing: false,
  },
  {
    id: 29,
    title: "Attack on Titan: Eren Attack Titan Tapestry",
    price: 25,
    image: "/images/merch/Attack-on-Titan/aot-poster-6.jpg",
    clothing: false,
  },
  {
    id: 30,
    title: "Attack on Titan: Mikasa Fractal Tapestry",
    price: 25,
    image: "/images/merch/Attack-on-Titan/aot-poster-7.jpg",
    clothing: false,
  },
  {
    id: 31,
    title: "Attack on Titan: Mikasa Scout Tapestry",
    price: 25,
    image: "/images/merch/Attack-on-Titan/aot-poster-8.jpg",
    clothing: false,
  },
  {
    id: 32,
    title: "Attack on Titan: Skyline Tapestry",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-poster-9.jpg",
    clothing: false,
  },
  {
    id: 33,
    title: "Attack on Titan: Cute Titan Tapestry",
    price: 25,
    image: "/images/merch/Attack-on-Titan/aot-poster-10.jpg",
    clothing: false,
  },
  {
    id: 34,
    title: "Attack on Titan: Metal Scout Wall Art",
    price: 45,
    image: "/images/merch/Attack-on-Titan/aot-poster-11.jpg",
    clothing: false,
  },
  {
    id: 35,
    title: "Attack on Titan: Mikasa Flowers Poster",
    price: 35,
    image: "/images/merch/Attack-on-Titan/aot-poster-12.jpg",
    clothing: false,
  },
  {
    id: 36,
    title: "Attack on Titan: Movie Poster Wall Art",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-poster-13.jpg",
    clothing: false,
  },
  {
    id: 37,
    title: "Attack on Titan: Bloody Levi Figurine",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-figurine.jpg",
    clothing: false,
  },
  {
    id: 38,
    title: "Attack on Titan: Funko Pop! Levi Keychain",
    price: 15,
    image: "/images/merch/Attack-on-Titan/aot-figurine-2.jpg",
    clothing: false,
  },
  {
    id: 39,
    title: "Attack on Titan: Levi Figurine",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 40,
    title: "Attack on Titan: Eren Figurine",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-figurine-4.jpg",
    clothing: false,
  },
  {
    id: 41,
    title: "Attack on Titan: Mikasa Figurine",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-figurine-5.jpg",
    clothing: false,
  },
  {
    id: 42,
    title: "Attack on Titan: Levi Mini Figurine",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 43,
    title: "Attack on Titan: Cleaning Levi Mini Figurine",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-figurine-4.jpg",
    clothing: false,
  },
  {
    id: 44,
    title: "Attack on Titan: Eren Figurine",
    price: 50,
    image: "/images/merch/Attack-on-Titan/aot-figurine-5.jpg",
    clothing: false,
  },
  {
    id: 45,
    title: "Attack on Titan: Scout Beenie",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-beenie.jpg",
    clothing: false,
  },
  {
    id: 46,
    title: "Attack on Titan: Keychain and Necklace Gift Set",
    price: 45,
    image: "/images/merch/Attack-on-Titan/aot-gift-set.jpg",
    clothing: false,
  },
  {
    id: 47,
    title: "Attack on Titan: Levi Mug",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-mug.jpg",
    clothing: false,
  },
  {
    id: 48,
    title: "Attack on Titan: Titans Mug",
    price: 30,
    image: "/images/merch/Attack-on-Titan/aot-mug-2.jpg",
    clothing: false,
  },
  {
    id: 49,
    title: "Attack on Titan: Levi Side Eyes Tote",
    price: 20,
    image: "/images/merch/Attack-on-Titan/aot-tote.jpg",
    clothing: false,
  },
  ///////////////
  // COWBOY BEBOP
  ///////////////
  {
    id: 50,
    title: "Cowboy Bebop: Swordfish Crewneck",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-jacket.jpg",
    clothing: true,
  },
  {
    id: 51,
    title: "Cowboy Bebop: Spike Black and White Hoodie",
    price: 50,
    image: "/images/merch/Cowboy-Bebop/cb-jacket-2.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-jacket-2b.jpg",
    clothing: true,
  },
  {
    id: 52,
    title: "Cowboy Bebop: Windbreaker",
    price: 60,
    image: "/images/merch/Cowboy-Bebop/cb-jacket-3.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-jacket-3b.jpg",
    clothing: true,
  },
  {
    id: 53,
    title: "Cowboy Bebop: Spike and Faye Hoodie",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 54,
    title: "Cowboy Bebop: Ed Emote Hoodie",
    price: 35,
    image: "/images/merch/Cowboy-Bebop/cb-jacket-5.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-jacket-5b.jpg",
    clothing: true,
  },
  {
    id: 55,
    title: "Cowboy Bebop: Minimal Hoodie",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 56,
    title: "Cowboy Bebop: Faye T-Shirt",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-shirt.jpg",
    clothing: true,
  },
  {
    id: 57,
    title: "Cowboy Bebop: Spike and Faye T-Shirt",
    price: 20,
    image: "/images/merch/Cowboy-Bebop/cb-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 58,
    title: "Cowboy Bebop: Ed T-Shirt",
    price: 25,
    image: "/images/merch/Cowboy-Bebop/cb-shirt-3.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-shirt-3b.jpg",
    clothing: true,
  },
  {
    id: 59,
    title: "Cowboy Bebop: Gateway Shuffle T-Shirt",
    price: 25,
    image: "/images/merch/Cowboy-Bebop/cb-shirt-4.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-shirt-4b.jpg",
    clothing: true,
  },
  {
    id: 60,
    title: "Cowboy Bebop: Ed Emotes Button Down Shirt",
    price: 40,
    image: "/images/merch/Cowboy-Bebop/cb-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 61,
    title: "Cowboy Bebop: Spike T-Shirt",
    price: 35,
    image: "/images/merch/Cowboy-Bebop/cb-shirt-6.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-shirt-6b.jpg",
    clothing: true,
  },
  {
    id: 62,
    title: "Cowboy Bebop: Spike and Swordfish Poster",
    price: 40,
    image: "/images/merch/Cowboy-Bebop/cb-poster.jpg",
    clothing: false,
  },
  {
    id: 63,
    title: "Cowboy Bebop: Spike Poster",
    price: 40,
    image: "/images/merch/Cowboy-Bebop/cb-poster-2.jpg",
    clothing: false,
  },
  {
    id: 64,
    title: "Cowboy Bebop: Movie Poster",
    price: 60,
    image: "/images/merch/Cowboy-Bebop/cb-poster-3.jpg",
    clothing: false,
  },
  {
    id: 65,
    title: "Cowboy Bebop: Crossbody Bag",
    price: 50,
    image: "/images/merch/Cowboy-Bebop/cb-bag.jpg",
    clothing: false,
  },
  {
    id: 66,
    title: "Cowboy Bebop: Coasters",
    price: 50,
    image: "/images/merch/Cowboy-Bebop/cb-coasters.jpg",
    clothing: false,
  },
  {
    id: 67,
    title: "Cowboy Bebop: Ed Emotes Hat",
    price: 45,
    image: "/images/merch/Cowboy-Bebop/cb-hat.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-hat-b.jpg",
    clothing: false,
  },
  {
    id: 68,
    title: "Cowboy Bebop: Lighter",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-lighter.jpg",
    clothing: false,
  },
  {
    id: 69,
    title: "Cowboy Bebop: Lounge Set",
    price: 70,
    image: "/images/merch/Cowboy-Bebop/cb-lounge-set.jpg",
    clothing: true,
  },
  {
    id: 70,
    title: "Cowboy Bebop: Swordfish Mug",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-mug.jpg",
    clothing: false,
  },
  {
    id: 71,
    title: "Cowboy Bebop: Spike Mug",
    price: 30,
    image: "/images/merch/Cowboy-Bebop/cb-mug-2.jpg",
    clothing: false,
  },
  {
    id: 72,
    title: "Cowboy Bebop: Pants",
    price: 40,
    image: "/images/merch/Cowboy-Bebop/cb-pants.jpg",
    clothing: true,
  },
  {
    id: 73,
    title: "Cowboy Bebop: Patch",
    price: 15,
    image: "/images/merch/Cowboy-Bebop/cb-patch.jpg",
    clothing: false,
  },
  {
    id: 74,
    title: "Cowboy Bebop: License Plate Frame",
    price: 25,
    image: "/images/merch/Cowboy-Bebop/cb-plate-frame.jpg",
    clothing: false,
  },
  {
    id: 75,
    title: "Cowboy Bebop: Gray Shorts",
    price: 40,
    image: "/images/merch/Cowboy-Bebop/cb-shorts.jpg",
    clothing: true,
  },
  {
    id: 76,
    title: "Cowboy Bebop: Red Shorts",
    price: 45,
    image: "/images/merch/Cowboy-Bebop/cb-shorts-2.jpg",
    clothing: true,
  },
  {
    id: 77,
    title: "Cowboy Bebop: Utility Vest",
    price: 80,
    image: "/images/merch/Cowboy-Bebop/cb-vest.jpg",
    image2: "/images/merch/Cowboy-Bebop/cb-vest-b.jpg",
    clothing: true,
  },
  ///////////////
  // DEMON SLAYER
  ///////////////
  {
    id: 78,
    title: "Demon Slayer: Cat Mask Hoodie",
    price: 80,
    image: "/images/merch/Demon-Slayer/ds-jacket.jpg",
    clothing: true,
  },
  {
    id: 79,
    title: "Demon Slayer: Logo Hoodie",
    price: 40,
    image: "/images/merch/Demon-Slayer/ds-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 80,
    title: "Demon Slayer: Nezuko Supreme Hoodie",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 81,
    title: "Demon Slayer: Zenitsu Crewneck",
    price: 50,
    image: "/images/merch/Demon-Slayer/ds-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 82,
    title: "Demon Slayer: Group Crewneck",
    price: 30,
    image: "/images/merch/Demon-Slayer/ds-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 83,
    title: "Demon Slayer: Wisteria Crewneck",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 84,
    title: "Demon Slayer: Longsleeve Logo Shirt",
    price: 30,
    image: "/images/merch/Demon-Slayer/ds-shirt.jpg",
    clothing: true,
  },
  {
    id: 85,
    title: "Demon Slayer: Tanjiro Panels T-Shirt",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 86,
    title: "Demon Slayer: Hashira T-Shirt",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 87,
    title: "Demon Slayer: Abbey Road T-Shirt",
    price: 30,
    image: "/images/merch/Demon-Slayer/ds-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 88,
    title: "Demon Slayer: Zenitsu T-Shirt",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 89,
    title: "Demon Slayer: Silhouette T-Shirt",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 90,
    title: "Demon Slayer: Bracelet",
    price: 30,
    image: "/images/merch/Demon-Slayer/ds-bracelet.jpg",
    clothing: false,
  },
  {
    id: 91,
    title: "Demon Slayer: Coasters",
    price: 40,
    image: "/images/merch/Demon-Slayer/ds-coasters.jpg",
    clothing: false,
  },
  {
    id: 92,
    title: "Demon Slayer: Hanafuda Earrings",
    price: 40,
    image: "/images/merch/Demon-Slayer/ds-earrings.jpg",
    clothing: false,
  },
  {
    id: 93,
    title: "Demon Slayer: Tengen's Swords Earrings",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-earrings-2.jpg",
    clothing: false,
  },
  {
    id: 94,
    title: "Demon Slayer: Inosuke Figurine",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-figurine.jpg",
    clothing: false,
  },
  {
    id: 95,
    title: "Demon Slayer: Nezuko Figurine",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-figurine-2.jpg",
    clothing: false,
  },
  {
    id: 96,
    title: "Demon Slayer: Tanjiro Figurine",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 97,
    title: "Demon Slayer: Zenitsu Figurine",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-figurine-4.jpg",
    clothing: false,
  },
  {
    id: 98,
    title: "Demon Slayer: Rengoku Mug",
    price: 30,
    image: "/images/merch/Demon-Slayer/ds-mug.jpg",
    clothing: false,
  },
  {
    id: 99,
    title: "Demon Slayer: Hanafuda Necklace",
    price: 25,
    image: "/images/merch/Demon-Slayer/ds-necklace.jpg",
    clothing: false,
  },
  {
    id: 100,
    title: "Demon Slayer: Green and Black Checkered Pants",
    price: 60,
    image: "/images/merch/Demon-Slayer/ds-pants.jpg",
    clothing: true,
  },
  //////////////
  // DRAGON BALL
  //////////////
  {
    id: 101,
    title: "Dragon Ball: Dragon Balls Crewneck",
    price: 60,
    image: "/images/merch/Dragon-Ball/db-jacket.jpg",
    clothing: true,
  },
  {
    id: 102,
    title: "Dragon Ball: Windbreaker",
    price: 80,
    image: "/images/merch/Dragon-Ball/db-jacket-2.jpg",
    image2: "/images/merch/Dragon-Ball/db-jacket-2b.jpg",
    clothing: true,
  },
  {
    id: 103,
    title: "Dragon Ball: Saiyan Hoodie",
    price: 60,
    image: "/images/merch/Dragon-Ball/db-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 104,
    title: "Dragon Ball: Eyes Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 105,
    title: "Dragon Ball: Goku Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 106,
    title: "Dragon Ball: Baby Goku Hoodie",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 107,
    title: "Dragon Ball: Saiyan Broly Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 108,
    title: "Dragon Ball: Vegeta Eyes Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 109,
    title: "Dragon Ball: Goku Red Moon Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 110,
    title: "Dragon Ball: Vegeta Silhouette Hoodie",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-jacket-10.jpg",
    clothing: true,
  },
  {
    id: 111,
    title: "Dragon Ball: Dragon Balls Button Down Shirt",
    price: 40,
    image: "/images/merch/Dragon-Ball/db-shirt.jpg",
    clothing: true,
  },
  {
    id: 112,
    title: "Dragon Ball: Goku vs. Vegeta Button Down Shirt",
    price: 40,
    image: "/images/merch/Dragon-Ball/db-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 113,
    title: "Dragon Ball: Goku vs. Frieza T-Shirt",
    price: 30,
    image: "/images/merch/Dragon-Ball/db-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 114,
    title: "Dragon Ball: Goku T-Shirt",
    price: 25,
    image: "/images/merch/Dragon-Ball/db-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 115,
    title: "Dragon Ball: Android No. 18 T-Shirt",
    price: 25,
    image: "/images/merch/Dragon-Ball/db-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 116,
    title: "Dragon Ball: Vegeta Longsleeve T-Shirt",
    price: 30,
    image: "/images/merch/Dragon-Ball/db-shirt-6.jpg",
    image2: "/images/merch/Dragon-Ball/db-shirt-6b.jpg",
    clothing: true,
  },
  {
    id: 117,
    title: "Dragon Ball: Goku Dragon Ball Z T-Shirt",
    price: 30,
    image: "/images/merch/Dragon-Ball/db-shirt-7.jpg",
    image2: "/images/merch/Dragon-Ball/db-shirt-7b.jpg",
    clothing: true,
  },
  {
    id: 118,
    title: "Dragon Ball: Vegeta Drake T-Shirt",
    price: 30,
    image: "/images/merch/Dragon-Ball/db-shirt-8.jpg",
    clothing: true,
  },
  {
    id: 119,
    title: "Dragon Ball: Vegeta Saiyan T-Shirt",
    price: 30,
    image: "/images/merch/Dragon-Ball/db-shirt-9.jpg",
    clothing: true,
  },
  {
    id: 120,
    title: "Dragon Ball: van Gogh Goku vs. Deathstar Poster",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-poster.jpg",
    clothing: false,
  },
  {
    id: 121,
    title: "Dragon Ball: Eyes Poster",
    price: 35,
    image: "/images/merch/Dragon-Ball/db-poster-2.jpg",
    clothing: false,
  },
  {
    id: 122,
    title: "Dragon Ball: Movie Poster",
    price: 40,
    image: "/images/merch/Dragon-Ball/db-poster-3.jpg",
    clothing: false,
  },
  {
    id: 123,
    title: "Dragon Ball: van Gogh Goku vs. Vegeta Poster",
    price: 45,
    image: "/images/merch/Dragon-Ball/db-poster-4.jpg",
    clothing: false,
  },
  {
    id: 124,
    title: "Dragon Ball: Dragon Balls",
    price: 40,
    image: "/images/merch/Dragon-Ball/db-balls.jpg",
    clothing: false,
  },
  {
    id: 125,
    title: "Dragon Ball: Dragon Balls and Shenron Stand",
    price: 100,
    image: "/images/merch/Dragon-Ball/db-balls-2.jpg",
    clothing: false,
  },
  {
    id: 126,
    title: "Dragon Ball: Dragon Balls Bracelet",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-bracelet.jpg",
    clothing: false,
  },
  {
    id: 127,
    title: "Dragon Ball: Dice Set",
    price: 60,
    image: "/images/merch/Dragon-Ball/db-dice.jpg",
    clothing: false,
  },
  {
    id: 128,
    title: "Dragon Ball: Senzu Bean Juice Flask",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-flask.jpg",
    clothing: false,
  },
  {
    id: 129,
    title: "Dragon Ball: Goku Mug",
    price: 40,
    image: "/images/merch/Dragon-Ball/db-mug.jpg",
    clothing: false,
  },
  {
    id: 130,
    title: "Dragon Ball: Sweatpants",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-pants.jpg",
    clothing: true,
  },
  {
    id: 131,
    title: "Dragon Ball: Saiyan Wallet",
    price: 50,
    image: "/images/merch/Dragon-Ball/db-wallet.jpg",
    clothing: false,
  },
  //////////////////////
  // FULLMETAL ALCHEMIST
  //////////////////////
  {
    id: 132,
    title: "Fullmetal Alchemist: Alchemy Flamel Crewneck",
    price: 40,
    image: "/images/merch/Fullmetal-Alchemist/fma-jacket.jpg",
    clothing: true,
  },
  {
    id: 133,
    title: "Fullmetal Alchemist: The Gate Crewneck",
    price: 40,
    image: "/images/merch/Fullmetal-Alchemist/fma-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 134,
    title: "Fullmetal Alchemist: Chimera Ugly Christmas Sweater",
    price: 60,
    image: "/images/merch/Fullmetal-Alchemist/fma-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 135,
    title: "Fullmetal Alchemist: Ed and Al T-Shirt",
    price: 30,
    image: "/images/merch/Fullmetal-Alchemist/fma-shirt.jpg",
    clothing: true,
  },
  {
    id: 136,
    title: "Fullmetal Alchemist: Ed and Al Fistbump T-Shirt",
    price: 30,
    image: "/images/merch/Fullmetal-Alchemist/fma-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 137,
    title: "Fullmetal Alchemist: Mustang T-Shirt",
    price: 30,
    image: "/images/merch/Fullmetal-Alchemist/fma-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 138,
    title: "Fullmetal Alchemist: Al with Spirits T-Shirt",
    price: 25,
    image: "/images/merch/Fullmetal-Alchemist/fma-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 139,
    title: "Fullmetal Alchemist: Al T-Shirt",
    price: 30,
    image: "/images/merch/Fullmetal-Alchemist/fma-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 140,
    title: "Fullmetal Alchemist: Ed Neon Sign",
    price: 75,
    image: "/images/merch/Fullmetal-Alchemist/fma-sign.jpg",
    clothing: false,
  },
  {
    id: 141,
    title: "Fullmetal Alchemist: Pocketwatch",
    price: 50,
    image: "/images/merch/Fullmetal-Alchemist/fma-watch.jpg",
    clothing: false,
  },
  {
    id: 142,
    title: "Fullmetal Alchemist: Transmutation Circle Dice Tray",
    price: 40,
    image: "/images/merch/Fullmetal-Alchemist/fma-dice-tray.jpg",
    clothing: false,
  },
  {
    id: 143,
    title: "Fullmetal Alchemist: Transmutation Circle Lighter",
    price: 25,
    image: "/images/merch/Fullmetal-Alchemist/fma-lighter.jpg",
    clothing: false,
  },
  {
    id: 144,
    title: "Fullmetal Alchemist: Ed and Al Notebook",
    price: 40,
    image: "/images/merch/Fullmetal-Alchemist/fma-notebook.jpg",
    clothing: false,
  },
  {
    id: 145,
    title: "Fullmetal Alchemist: The Gates Pin",
    price: 15,
    image: "/images/merch/Fullmetal-Alchemist/fma-pin.jpg",
    clothing: false,
  },
  {
    id: 146,
    title: "Fullmetal Alchemist: Al and Cats Blue Pin",
    price: 10,
    image: "/images/merch/Fullmetal-Alchemist/fma-pin-2.jpg",
    clothing: false,
  },
  {
    id: 147,
    title: "Fullmetal Alchemist: Alchemy Flamel Pin",
    price: 10,
    image: "/images/merch/Fullmetal-Alchemist/fma-pin-3.jpg",
    clothing: false,
  },
  {
    id: 148,
    title: "Fullmetal Alchemist: Al and Cats Gray Pin",
    price: 10,
    image: "/images/merch/Fullmetal-Alchemist/fma-pin-4.jpg",
    clothing: false,
  },
  {
    id: 149,
    title: "Fullmetal Alchemist: Alchemy Flamel Ring",
    price: 20,
    image: "/images/merch/Fullmetal-Alchemist/fma-ring.jpg",
    clothing: false,
  },
  {
    id: 150,
    title: "Fullmetal Alchemist: Transmutation Circle Rug",
    price: 50,
    image: "/images/merch/Fullmetal-Alchemist/fma-rug.jpg",
    clothing: false,
  },
  //////////////////
  // HUNTER X HUNTER
  //////////////////
  {
    id: 151,
    title: "Hunter x Hunter: Killua Drinking Crewneck",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-jacket.jpg",
    clothing: true,
  },
  {
    id: 152,
    title: "Hunter x Hunter: Killua Eyes Crewneck",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 153,
    title: "Hunter x Hunter: Eyes Crewneck",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 154,
    title: "Hunter x Hunter: Meruem vs. Komugi Crewneck",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 155,
    title: "Hunter x Hunter: Purple and Blue Split Hoodie",
    price: 70,
    image: "/images/merch/HunterxHunter/hxh-jacket-5.jpg",
    image2: "/images/merch/HunterxHunter/hxh-jacket-5b.jpg",
    clothing: true,
  },
  {
    id: 156,
    title: "Hunter x Hunter: Red Hunter Hoodie",
    price: 70,
    image: "/images/merch/HunterxHunter/hxh-jacket-6.jpg",
    image2: "/images/merch/HunterxHunter/hxh-jacket-6b.jpg",
    clothing: true,
  },
  {
    id: 157,
    title: "Hunter x Hunter: Killua Drinking T-Shirt",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-shirt.jpg",
    clothing: true,
  },
  {
    id: 158,
    title: "Hunter x Hunter: Gon and Killua Bubble Gum T-Shirt",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 159,
    title: "Hunter x Hunter: Abbey Road T-Shirt",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 160,
    title: "Hunter x Hunter: Gon and Killua T-Shirt",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-shirt-4.jpg",
    image2: "/images/merch/HunterxHunter/hxh-shirt-4b.jpg",
    clothing: true,
  },
  {
    id: 161,
    title: "Hunter x Hunter: Tie-Dye T-Shirt",
    price: 30,
    image: "/images/merch/HunterxHunter/hxh-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 162,
    title: "Hunter x Hunter: Button Down Shirt",
    price: 50,
    image: "/images/merch/HunterxHunter/hxh-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 163,
    title: "Hunter x Hunter: Longsleeve T-Shirt",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-shirt-7.jpg",
    clothing: true,
  },
  {
    id: 164,
    title: "Hunter x Hunter: Killua T-Shirt",
    price: 35,
    image: "/images/merch/HunterxHunter/hxh-shirt-8.jpg",
    image2: "/images/merch/HunterxHunter/hxh-shirt-8b.jpg",
    clothing: true,
  },
  {
    id: 165,
    title: "Hunter x Hunter: Movie Poster",
    price: 50,
    image: "/images/merch/HunterxHunter/hxh-poster.jpg",
    clothing: false,
  },
  {
    id: 166,
    title: "Hunter x Hunter: Killua Poster",
    price: 30,
    image: "/images/merch/HunterxHunter/hxh-poster-2.jpg",
    clothing: false,
  },
  {
    id: 167,
    title: "Hunter x Hunter: Killua Cyberpunk Poster",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-poster-3.jpg",
    clothing: false,
  },
  {
    id: 168,
    title: "Hunter x Hunter: Killua Mountain Poster",
    price: 30,
    image: "/images/merch/HunterxHunter/hxh-poster-4.jpg",
    clothing: false,
  },
  {
    id: 169,
    title: "Hunter x Hunter: Sling Bag",
    price: 70,
    image: "/images/merch/HunterxHunter/hxh-bag.jpg",
    image2: "/images/merch/HunterxHunter/hxh-bag-b.jpg",
    clothing: false,
  },
  {
    id: 170,
    title: "Hunter x Hunter: Killua Beenie",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-beenie.jpg",
    image2: "/images/merch/HunterxHunter/hxh-beenie-b.jpg",
    clothing: false,
  },
  {
    id: 171,
    title: "Hunter x Hunter: Hunter Beenie",
    price: 20,
    image: "/images/merch/HunterxHunter/hxh-beenie-2.jpg",
    clothing: false,
  },
  {
    id: 172,
    title: "Hunter x Hunter: Judgement Chain Earrings",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-earrings.jpg",
    clothing: false,
  },
  {
    id: 173,
    title: "Hunter x Hunter: Yin Yang Gon and Killua Hat",
    price: 25,
    image: "/images/merch/HunterxHunter/hxh-hat.jpg",
    clothing: false,
  },
  {
    id: 174,
    title: "Hunter x Hunter: Hisoka Hat",
    price: 20,
    image: "/images/merch/HunterxHunter/hxh-hat-2.jpg",
    clothing: false,
  },
  {
    id: 175,
    title: "Hunter x Hunter: Lounge Set",
    price: 90,
    image: "/images/merch/HunterxHunter/hxh-lounge-set.jpg",
    clothing: true,
  },
  {
    id: 176,
    title: "Hunter x Hunter: Hisoka Shorts",
    price: 40,
    image: "/images/merch/HunterxHunter/hxh-shorts.jpg",
    clothing: true,
  },
  {
    id: 177,
    title: "Hunter x Hunter: Hunter Shorts",
    price: 30,
    image: "/images/merch/HunterxHunter/hxh-shorts-2.jpg",
    clothing: true,
  },
  {
    id: 178,
    title: "Hunter x Hunter: Gon and Killua Shorts",
    price: 35,
    image: "/images/merch/HunterxHunter/hxh-shorts-3.jpg",
    clothing: true,
  },
  {
    id: 179,
    title: "Hunter x Hunter: Slides",
    price: 50,
    image: "/images/merch/HunterxHunter/hxh-slides.jpg",
    clothing: true,
  },
  {
    id: 180,
    title: "Hunter x Hunter: Killua Sticker",
    price: 10,
    image: "/images/merch/HunterxHunter/hxh-sticker.jpg",
    clothing: false,
  },
  {
    id: 181,
    title: "Hunter x Hunter: Utility Vest",
    price: 35,
    image: "/images/merch/HunterxHunter/hxh-vest.jpg",
    image2: "/images/merch/HunterxHunter/hxh-vest-b.jpg",
    clothing: true,
  },
  /////////////////
  // JUJUTSU KAISEN
  /////////////////
  {
    id: 182,
    title: "Jujutsu Kaisen: Black and White Team Crewneck",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket.jpg",
    clothing: true,
  },
  {
    id: 183,
    title: "Jujutsu Kaisen: Tokyo Jujutsu High Crewneck",
    price: 50,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 184,
    title: "Jujutsu Kaisen: Gojo Satoru Crewneck",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 185,
    title: "Jujutsu Kaisen: Ten Shadows Crewneck",
    price: 35,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 186,
    title: "Jujutsu Kaisen: Itadori Yuji Crewneck",
    price: 35,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 187,
    title: "Jujutsu Kaisen: Itadori Yuji Hoodie",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 188,
    title: "Jujutsu Kaisen: Credits Hoodie",
    price: 40,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 189,
    title: "Jujutsu Kaisen: Gojo Satoru Hoodie",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 190,
    title: "Jujutsu Kaisen: Gojo Satoru Eyes Hoodie",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 191,
    title: "Jujutsu Kaisen: Fushiguro Megumi Hoodie",
    price: 45,
    image: "/images/merch/Jujutsu-Kaisen/jjk-jacket-10.jpg",
    clothing: true,
  },
  {
    id: 192,
    title: "Jujutsu Kaisen: Itadori Yuji T-Shirt",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-shirt.jpg",
    clothing: true,
  },
  {
    id: 193,
    title: "Jujutsu Kaisen: Gojo Satoru T-Shirt",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 194,
    title: "Jujutsu Kaisen: Gojo Satoru With Panels T-Shirt",
    price: 35,
    image: "/images/merch/Jujutsu-Kaisen/jjk-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 195,
    title: "Jujutsu Kaisen: Itadori Yuji Fighting T-Shirt",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 196,
    title: "Jujutsu Kaisen: Gojo Satoru Airpod Case",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-airpod-case.jpg",
    clothing: false,
  },
  {
    id: 197,
    title: "Jujutsu Kaisen: Gojo Satoru Eyes Bucket Hat",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-hat.jpg",
    clothing: false,
  },
  {
    id: 198,
    title: "Jujutsu Kaisen: Itadori Yuji Wall Art",
    price: 60,
    image: "/images/merch/Jujutsu-Kaisen/jjk-poster.jpg",
    clothing: false,
  },
  {
    id: 199,
    title: "Jujutsu Kaisen: Gojo Satoru Poster",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-poster-2.jpg",
    clothing: false,
  },
  {
    id: 200,
    title: "Jujutsu Kaisen: Team Poster",
    price: 30,
    image: "/images/merch/Jujutsu-Kaisen/jjk-poster-3.jpg",
    clothing: false,
  },
  {
    id: 201,
    title: "Jujutsu Kaisen: Credits Tote",
    price: 40,
    image: "/images/merch/Jujutsu-Kaisen/jjk-tote.jpg",
    clothing: false,
  },
  ///////////////////
  // MY HERO ACADEMIA
  ///////////////////
  {
    id: 202,
    title: "My Hero Academia: Eyes Hoodie",
    price: 40,
    image: "/images/merch/My-Hero-Academia/mha-jacket.jpg",
    clothing: true,
  },
  {
    id: 203,
    title: "My Hero Academia: Faces Hoodie",
    price: 40,
    image: "/images/merch/My-Hero-Academia/mha-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 204,
    title: "My Hero Academia: Friends Hoodie",
    price: 40,
    image: "/images/merch/My-Hero-Academia/mha-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 205,
    title: "My Hero Academia: Bakugo Hoodie",
    price: 40,
    image: "/images/merch/My-Hero-Academia/mha-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 206,
    title: "My Hero Academia: UA Hoodie",
    price: 30,
    image: "/images/merch/My-Hero-Academia/mha-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 207,
    title: "My Hero Academia: Todoroki Shoto Hoodie",
    price: 40,
    image: "/images/merch/My-Hero-Academia/mha-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 208,
    title: "My Hero Academia: Todoroki Shoto T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt.jpg",
    clothing: true,
  },
  {
    id: 209,
    title: "My Hero Academia: Dabi T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 210,
    title: "My Hero Academia: Izuku Midoriya T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 211,
    title: "My Hero Academia: Plus Ultra T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 212,
    title: "My Hero Academia: Winter School T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 213,
    title: "My Hero Academia: Lunch T-Shirt",
    price: 25,
    image: "/images/merch/My-Hero-Academia/mha-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 214,
    title: "My Hero Academia: Sunrise Wall Art",
    price: 60,
    image: "/images/merch/My-Hero-Academia/mha-poster.jpg",
    clothing: false,
  },
  {
    id: 215,
    title: "My Hero Academia: Plus Ultra Poster",
    price: 20,
    image: "/images/merch/My-Hero-Academia/mha-poster-2.jpg",
    clothing: false,
  },
  {
    id: 216,
    title: "My Hero Academia: Izuku Midoriya Poster",
    price: 20,
    image: "/images/merch/My-Hero-Academia/mha-poster-3.jpg",
    clothing: false,
  },
  {
    id: 217,
    title: "My Hero Academia: Todoroki Shoto Poster",
    price: 20,
    image: "/images/merch/My-Hero-Academia/mha-poster-4.jpg",
    clothing: false,
  },
  {
    id: 218,
    title: "My Hero Academia: Dabi Poster",
    price: 20,
    image: "/images/merch/My-Hero-Academia/mha-poster-5.jpg",
    clothing: false,
  },
  {
    id: 219,
    title: "My Hero Academia: Bakugo Figurine",
    price: 70,
    image: "/images/merch/My-Hero-Academia/mha-figurine.jpg",
    clothing: false,
  },
  {
    id: 220,
    title: "My Hero Academia: Midoriya Fighting Figurine",
    price: 50,
    image: "/images/merch/My-Hero-Academia/mha-figurine-2.jpg",
    clothing: false,
  },
  {
    id: 221,
    title: "My Hero Academia: Bakugo Fighting Figurine",
    price: 50,
    image: "/images/merch/My-Hero-Academia/mha-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 222,
    title: "My Hero Academia: Midoriya Figurine",
    price: 70,
    image: "/images/merch/My-Hero-Academia/mha-figurine-4.jpg",
    clothing: false,
  },
  {
    id: 223,
    title: "My Hero Academia: Shoto Figurine",
    price: 70,
    image: "/images/merch/My-Hero-Academia/mha-figurine-5.jpg",
    clothing: false,
  },
  /////////
  // NARUTO
  /////////
  {
    id: 224,
    title: "Naruto: Sage of Six Paths Hoodie",
    price: 60,
    image: "/images/merch/Naruto/nar-jacket.jpg",
    clothing: true,
  },
  {
    id: 225,
    title: "Naruto: Naruto Shippuden Hoodie",
    price: 60,
    image: "/images/merch/Naruto/nar-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 226,
    title: "Naruto: Akatsuki Hoodie",
    price: 60,
    image: "/images/merch/Naruto/nar-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 227,
    title: "Naruto: Itachi Hoodie",
    price: 45,
    image: "/images/merch/Naruto/nar-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 228,
    title: "Naruto: Reverse Sage of Six Paths Hoodie",
    price: 60,
    image: "/images/merch/Naruto/nar-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 229,
    title: "Naruto: Ichiraku Ramen Hoodie",
    price: 40,
    image: "/images/merch/Naruto/nar-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 230,
    title: "Naruto: Uchiha Hoodie",
    price: 40,
    image: "/images/merch/Naruto/nar-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 231,
    title: "Naruto: Jiraiya Crewneck",
    price: 45,
    image: "/images/merch/Naruto/nar-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 232,
    title: "Naruto: Itachi Crewneck",
    price: 45,
    image: "/images/merch/Naruto/nar-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 233,
    title: "Naruto: Gaara Crewneck",
    price: 45,
    image: "/images/merch/Naruto/nar-jacket-10.jpg",
    clothing: true,
  },
  {
    id: 234,
    title: "Naruto: Akatsuki Ugly Christmas Sweater",
    price: 70,
    image: "/images/merch/Naruto/nar-jacket-11.jpg",
    clothing: true,
  },
  {
    id: 235,
    title: "Naruto: Uchiha Clan Basketball Jersey",
    price: 70,
    image: "/images/merch/Naruto/nar-shirt.jpg",
    image2: "/images/merch/Naruto/nar-shirt-b.jpg",
    clothing: true,
  },
  {
    id: 236,
    title: "Naruto: Naruto and Sasuke T-Shirt",
    price: 30,
    image: "/images/merch/Naruto/nar-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 237,
    title: "Naruto: Akatsuki Airpod Case",
    price: 25,
    image: "/images/merch/Naruto/nar-airpod-case.jpg",
    clothing: false,
  },
  {
    id: 238,
    title: "Naruto: Itachi Figurine",
    price: 50,
    image: "/images/merch/Naruto/nar-figurine.jpg",
    clothing: false,
  },
  {
    id: 239,
    title: "Naruto: Minato Figurine",
    price: 60,
    image: "/images/merch/Naruto/nar-figurine-2.jpg",
    clothing: false,
  },
  {
    id: 240,
    title: "Naruto: Obito Figurine",
    price: 100,
    image: "/images/merch/Naruto/nar-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 241,
    title: "Naruto: Sage and Tailed-Beast Mode Naruto Figurine",
    price: 300,
    image: "/images/merch/Naruto/nar-figurine-4.jpg",
    clothing: false,
  },
  {
    id: 242,
    title: "Naruto: Jiraiya Figurine",
    price: 75,
    image: "/images/merch/Naruto/nar-figurine-5.jpg",
    clothing: false,
  },
  {
    id: 243,
    title: "Naruto: Gaara Figurine",
    price: 85,
    image: "/images/merch/Naruto/nar-figurine-6.jpg",
    clothing: false,
  },
  {
    id: 244,
    title: "Naruto: Rogue Leaf Village Headband",
    price: 30,
    image: "/images/merch/Naruto/nar-headband.jpg",
    clothing: false,
  },
  {
    id: 245,
    title: "Naruto: Leaf Village Headband",
    price: 30,
    image: "/images/merch/Naruto/nar-headband-2.jpg",
    clothing: false,
  },
  ////////////
  // ONE PIECE
  ////////////
  {
    id: 246,
    title: "One Piece: Ugly Christmas Sweater",
    price: 60,
    image: "/images/merch/One-Piece/op-jacket.jpg",
    clothing: true,
  },
  {
    id: 247,
    title: "One Piece: Logo and Luffy Hoodie",
    price: 40,
    image: "/images/merch/One-Piece/op-jacket-2.jpg",
    image2: "/images/merch/One-Piece/op-jacket-2b.jpg",
    clothing: true,
  },
  {
    id: 248,
    title: "One Piece: Devil Fruit Crewneck",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 249,
    title: "One Piece: Group Crewneck",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 250,
    title: "One Piece: Chopper Crewneck",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 251,
    title: "One Piece: Straw Hat Pirates Crewneck",
    price: 40,
    image: "/images/merch/One-Piece/op-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 252,
    title: "One Piece: Angry Luffy Hoodie",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 253,
    title: "One Piece: The Great Wave Crewneck",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 254,
    title: "One Piece: The Pirate King Hoodie",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 255,
    title: "One Piece: Luffy Hoodie",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-10.jpg",
    clothing: true,
  },
  {
    id: 256,
    title: "One Piece: Gomu Gomu Crewneck",
    price: 40,
    image: "/images/merch/One-Piece/op-jacket-11.jpg",
    clothing: true,
  },
  {
    id: 257,
    title: "One Piece: Just Do It Later Hoodie",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-12.jpg",
    clothing: true,
  },
  {
    id: 258,
    title: "One Piece: Luffy Silhouette Crewneck",
    price: 45,
    image: "/images/merch/One-Piece/op-jacket-13.jpg",
    clothing: true,
  },
  {
    id: 259,
    title: "One Piece: Logo Button Down Shirt",
    price: 35,
    image: "/images/merch/One-Piece/op-shirt.jpg",
    clothing: true,
  },
  {
    id: 260,
    title: "One Piece: Roronoa Zoro Poster",
    price: 25,
    image: "/images/merch/One-Piece/op-poster.jpg",
    clothing: false,
  },
  {
    id: 261,
    title: "One Piece: Luffy's Hat Baseball Hat",
    price: 25,
    image: "/images/merch/One-Piece/op-hat.jpg",
    clothing: false,
  },
  {
    id: 262,
    title: "One Piece: Keychain",
    price: 10,
    image: "/images/merch/One-Piece/op-keychain.jpg",
    clothing: false,
  },
  {
    id: 263,
    title: "One Piece: Lighter",
    price: 25,
    image: "/images/merch/One-Piece/op-lighter.jpg",
    clothing: false,
  },
  {
    id: 264,
    title: "One Piece: Pint Mug",
    price: 15,
    image: "/images/merch/One-Piece/op-mug.jpg",
    clothing: false,
  },
  {
    id: 265,
    title: "One Piece: Ring",
    price: 15,
    image: "/images/merch/One-Piece/op-ring.jpg",
    clothing: false,
  },
  {
    id: 266,
    title: "One Piece: Logo Shorts",
    price: 40,
    image: "/images/merch/One-Piece/op-shorts.jpg",
    clothing: true,
  },
  {
    id: 267,
    title: "One Piece: Luffy Shorts",
    price: 40,
    image: "/images/merch/One-Piece/op-shorts-2.jpg",
    clothing: true,
  },
  {
    id: 268,
    title: "One Piece: Pocket Watch",
    price: 30,
    image: "/images/merch/One-Piece/op-watch.jpg",
    clothing: false,
  },
  //////////
  // POKEMON
  //////////
  {
    id: 269,
    title: "Pokemon: Halloween Pikachu Crewneck",
    price: 40,
    image: "/images/merch/Pokemon/pok-jacket.jpg",
    clothing: true,
  },
  {
    id: 270,
    title: "Pokemon: Pikachu Hoodie",
    price: 45,
    image: "/images/merch/Pokemon/pok-jacket-2.jpg",
    image2: "/images/merch/Pokemon/pok-jacket-2b.jpg",
    clothing: true,
  },
  {
    id: 271,
    title: "Pokemon: Ugly Christmas Sweater",
    price: 65,
    image: "/images/merch/Pokemon/pok-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 272,
    title: "Pokemon: Psyduck T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt.jpg",
    clothing: true,
  },
  {
    id: 273,
    title: "Pokemon: 1995 T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 274,
    title: "Pokemon: Hawaiian Shirt",
    price: 35,
    image: "/images/merch/Pokemon/pok-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 275,
    title: "Pokemon: Legendary Birds Tie-Dye T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 276,
    title: "Pokemon: Eeveelutions T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 277,
    title: "Pokemon: Pikachu T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 278,
    title: "Pokemon: Starters T-Shirt",
    price: 40,
    image: "/images/merch/Pokemon/pok-shirt-7.jpg",
    clothing: true,
  },
  {
    id: 279,
    title: "Pokemon: Pikachu Panel T-Shirt",
    price: 30,
    image: "/images/merch/Pokemon/pok-shirt-8.jpg",
    clothing: true,
  },
  {
    id: 280,
    title: "Pokemon: Kanto Gym Badges",
    price: 30,
    image: "/images/merch/Pokemon/pok-badges.jpg",
    clothing: false,
  },
  {
    id: 281,
    title: "Pokemon: Coasters",
    price: 25,
    image: "/images/merch/Pokemon/pok-coasters.jpg",
    clothing: false,
  },
  {
    id: 282,
    title: "Pokemon: Pikachu Neon Light",
    price: 40,
    image: "/images/merch/Pokemon/pok-light.jpg",
    clothing: false,
  },
  {
    id: 283,
    title: "Pokemon: Snorlax Neon Light",
    price: 40,
    image: "/images/merch/Pokemon/pok-light-2.jpg",
    clothing: false,
  },
  {
    id: 284,
    title: "Pokemon: Mimikyu Plush",
    price: 35,
    image: "/images/merch/Pokemon/pok-plush.jpg",
    clothing: false,
  },
  {
    id: 285,
    title: "Pokemon: Magikarp Poster",
    price: 20,
    image: "/images/merch/Pokemon/pok-poster.jpg",
    clothing: false,
  },
  {
    id: 286,
    title: "Pokemon: Kanto Starters Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-2.jpg",
    clothing: false,
  },
  {
    id: 287,
    title: "Pokemon: The Great Wave Gyarados Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-3.jpg",
    clothing: false,
  },
  {
    id: 288,
    title: "Pokemon: Ninetails Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-4.jpg",
    clothing: false,
  },
  {
    id: 289,
    title: "Pokemon: River Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-5.jpg",
    clothing: false,
  },
  {
    id: 290,
    title: "Pokemon: Bulbasaur Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-6.jpg",
    clothing: false,
  },
  {
    id: 291,
    title: "Pokemon: Lugia Poster",
    price: 25,
    image: "/images/merch/Pokemon/pok-poster-7.jpg",
    clothing: false,
  },
  {
    id: 292,
    title: "Pokemon: Bulbasaur Pot",
    price: 50,
    image: "/images/merch/Pokemon/pok-pot.jpg",
    clothing: false,
  },
  {
    id: 293,
    title: "Pokemon: Oddish Pot",
    price: 30,
    image: "/images/merch/Pokemon/pok-pot-2.jpg",
    clothing: false,
  },
  {
    id: 294,
    title: "Pokemon: Door Mat",
    price: 30,
    image: "/images/merch/Pokemon/pok-rug.jpg",
    clothing: false,
  },
  {
    id: 295,
    title: "Pokemon: Generation 1 Starter Pokemon Diorama",
    price: 40,
    image: "/images/merch/Pokemon/pok-scene.jpg",
    clothing: false,
  },
  ////////////////
  // STUDIO GHIBLI
  ////////////////
  {
    id: 296,
    title: "Studio Ghibli: Totoro Ugly Christmas Sweater",
    price: 65,
    image: "/images/merch/Studio-Ghibli/sg-jacket.jpg",
    clothing: true,
  },
  {
    id: 297,
    title: "Studio Ghibli: No-Face Ugly Christmas Sweater",
    price: 65,
    image: "/images/merch/Studio-Ghibli/sg-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 298,
    title: "Studio Ghibli: Characters Crewneck",
    price: 45,
    image: "/images/merch/Studio-Ghibli/sg-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 299,
    title: "Studio Ghibli: No-Face Crewneck",
    price: 45,
    image: "/images/merch/Studio-Ghibli/sg-jacket-4.jpg",
    clothing: true,
  },
  {
    id: 300,
    title: "Studio Ghibli: Princess Mononoke Ugly Christmas Sweater",
    price: 65,
    image: "/images/merch/Studio-Ghibli/sg-jacket-5.jpg",
    clothing: true,
  },
  {
    id: 301,
    title: "Studio Ghibli: My Neighbor Totoro Crewneck",
    price: 50,
    image: "/images/merch/Studio-Ghibli/sg-jacket-6.jpg",
    clothing: true,
  },
  {
    id: 302,
    title: "Studio Ghibli: Kiki Not in Service Crewneck",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-jacket-7.jpg",
    clothing: true,
  },
  {
    id: 303,
    title: "Studio Ghibli: Spirited Away Soot Sprites Crewneck",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-jacket-8.jpg",
    clothing: true,
  },
  {
    id: 304,
    title: "Studio Ghibli: Kiki's Bakery Crewneck",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-jacket-9.jpg",
    clothing: true,
  },
  {
    id: 305,
    title: "Studio Ghibli: Howl's Moving Castle Crewneck",
    price: 45,
    image: "/images/merch/Studio-Ghibli/sg-jacket-10.jpg",
    clothing: true,
  },
  {
    id: 306,
    title: "Studio Ghibli: Ramen Crewneck",
    price: 45,
    image: "/images/merch/Studio-Ghibli/sg-jacket-11.jpg",
    clothing: true,
  },
  {
    id: 307,
    title: "Studio Ghibli: Calcifer Crewneck",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-jacket-12.jpg",
    clothing: true,
  },
  {
    id: 308,
    title: "Studio Ghibli: Avatar Elements T-Shirt",
    price: 30,
    image: "/images/merch/Studio-Ghibli/sg-shirt.jpg",
    clothing: true,
  },
  {
    id: 309,
    title: "Studio Ghibli: Howl's Moving Castle Button Down Shirt",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 310,
    title: "Studio Ghibli: Princess Mononoke Spirits Button Down Shirt",
    price: 40,
    image: "/images/merch/Studio-Ghibli/sg-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 311,
    title: "Studio Ghibli: Princess Mononoke T-Shirt",
    price: 30,
    image: "/images/merch/Studio-Ghibli/sg-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 312,
    title: "Studio Ghibli: Logo T-Shirt",
    price: 25,
    image: "/images/merch/Studio-Ghibli/sg-shirt-5.jpg",
    clothing: true,
  },
  {
    id: 313,
    title: "Studio Ghibli: Totoro Pocket T-Shirt",
    price: 20,
    image: "/images/merch/Studio-Ghibli/sg-shirt-6.jpg",
    clothing: true,
  },
  {
    id: 314,
    title: "Studio Ghibli: Circle T-Shirt",
    price: 30,
    image: "/images/merch/Studio-Ghibli/sg-shirt-7.jpg",
    clothing: true,
  },
  {
    id: 315,
    title: "Studio Ghibli: Totoro Wooden Bowl",
    price: 20,
    image: "/images/merch/Studio-Ghibli/sg-bowl.jpg",
    clothing: false,
  },
  {
    id: 316,
    title: "Studio Ghibli: Totoro Cup",
    price: 15,
    image: "/images/merch/Studio-Ghibli/sg-cup.jpg",
    clothing: false,
  },
  {
    id: 317,
    title: "Studio Ghibli: Totoro Coffee Mug",
    price: 15,
    image: "/images/merch/Studio-Ghibli/sg-cup-2.jpg",
    clothing: false,
  },
  {
    id: 318,
    title: "Studio Ghibli: Castle in the Sky Crystal Necklace",
    price: 20,
    image: "/images/merch/Studio-Ghibli/sg-necklace.jpg",
    clothing: false,
  },
  {
    id: 319,
    title: "Studio Ghibli: Howl's Moving Castle Pajama Pants",
    price: 25,
    image: "/images/merch/Studio-Ghibli/sg-pants.jpg",
    clothing: true,
  },
  {
    id: 320,
    title: "Studio Ghibli: Princess Mononoke Spirits Pajama Pants",
    price: 25,
    image: "/images/merch/Studio-Ghibli/sg-pants-2.jpg",
    clothing: true,
  },
  {
    id: 321,
    title: "Studio Ghibli: Totoro Tote",
    price: 30,
    image: "/images/merch/Studio-Ghibli/sg-tote.jpg",
    clothing: false,
  },
  ////////
  // OTHER
  ////////
  {
    id: 322,
    title: "Anime Friends Mashup Hoodie",
    price: 40,
    image: "/images/merch/Other/anime-jacket.jpg",
    clothing: true,
  },
  {
    id: 323,
    title: "Bleach: Ichigo Figurine",
    price: 100,
    image: "/images/merch/Other/ble-figurine.jpg",
    clothing: false,
  },
  {
    id: 324,
    title: "Bleach: Ichigo Crewneck",
    price: 40,
    image: "/images/merch/Other/ble-jacket.jpg",
    clothing: true,
  },
  {
    id: 325,
    title: "Bleach: Ichigo Hoodie",
    price: 50,
    image: "/images/merch/Other/ble-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 326,
    title: "Bleach: Group T-Shirt",
    price: 25,
    image: "/images/merch/Other/ble-shirt.jpg",
    clothing: true,
  },
  {
    id: 327,
    title: "Death Note: Ryuk Hoodie",
    price: 50,
    image: "/images/merch/Other/dn-jacket.jpg",
    clothing: true,
  },
  {
    id: 328,
    title: "Death Note: Ryuk Silhouette Hoodie",
    price: 50,
    image: "/images/merch/Other/dn-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 329,
    title: "Death Note: Notebook",
    price: 20,
    image: "/images/merch/Other/dn-notebook.jpg",
    clothing: false,
  },
  {
    id: 330,
    title: "Death Note: Ring",
    price: 15,
    image: "/images/merch/Other/dn-ring.jpg",
    clothing: false,
  },
  {
    id: 331,
    title: "Hikyuu: Karasuno Volleyball Club Hoodie",
    price: 50,
    image: "/images/merch/Other/hku-jacket.jpg",
    clothing: true,
  },
  {
    id: 332,
    title: "Hikyuu: Karasuno Volleyball Club Crewneck",
    price: 40,
    image: "/images/merch/Other/hku-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 333,
    title: "Hikyuu: Panels Coffee Mug",
    price: 20,
    image: "/images/merch/Other/hku-mug.jpg",
    clothing: false,
  },
  {
    id: 334,
    title: "Hikyuu: Comic Coffee Mug",
    price: 20,
    image: "/images/merch/Other/hku-mug-2.jpg",
    clothing: false,
  },
  {
    id: 335,
    title: "Hikyuu: Group Poster",
    price: 25,
    image: "/images/merch/Other/hku-poster.jpg",
    clothing: false,
  },
  {
    id: 336,
    title: "Hikyuu: Comic T-Shirt",
    price: 25,
    image: "/images/merch/Other/hku-shirt.jpg",
    clothing: true,
  },
  {
    id: 337,
    title: "Hikyuu: Back to Back T-Shirt",
    price: 25,
    image: "/images/merch/Other/hku-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 338,
    title: "Hikyuu: Eyes T-Shirt",
    price: 25,
    image: "/images/merch/Other/hku-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 339,
    title: "One Punch Man: Saitama OK Red Moon Hoodie",
    price: 35,
    image: "/images/merch/Other/opm-jacket.jpg",
    clothing: true,
  },
  {
    id: 340,
    title: "One Punch Man: Saitama OK Hoodie",
    price: 35,
    image: "/images/merch/Other/opm-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 341,
    title: "One Punch Man: Saitama OK Supreme Hoodie",
    price: 35,
    image: "/images/merch/Other/opm-jacket-3.jpg",
    clothing: true,
  },
  {
    id: 342,
    title: "One Punch Man: Saitama Red and Blue T-Shirt",
    price: 35,
    image: "/images/merch/Other/opm-shirt.jpg",
    clothing: true,
  },
  {
    id: 343,
    title: "Spy x Family: Yor Earrings",
    price: 15,
    image: "/images/merch/Other/sf-earrings.jpg",
    clothing: false,
  },
  {
    id: 344,
    title: "Spy x Family: Anya Figurine",
    price: 35,
    image: "/images/merch/Other/sf-figurine.jpg",
    clothing: false,
  },
  {
    id: 345,
    title: "Spy x Family: Loid Figurine",
    price: 40,
    image: "/images/merch/Other/sf-figurine-2.jpg",
    clothing: false,
  },
  {
    id: 346,
    title: "Spy x Family: Yor Figurine",
    price: 40,
    image: "/images/merch/Other/sf-figurine-3.jpg",
    clothing: false,
  },
  {
    id: 347,
    title: "Spy x Family: Anya Heh Hoodie",
    price: 35,
    image: "/images/merch/Other/sf-jacket.jpg",
    clothing: true,
  },
  {
    id: 348,
    title: "Spy x Family: Anya Heh Crewneck",
    price: 30,
    image: "/images/merch/Other/sf-jacket-2.jpg",
    clothing: true,
  },
  {
    id: 349,
    title: "Spy x Family: Anya Faces Coffee Mug",
    price: 20,
    image: "/images/merch/Other/sf-mug.jpg",
    clothing: false,
  },
  {
    id: 350,
    title: "Spy x Family: Anya Studying Coffee Mug",
    price: 20,
    image: "/images/merch/Other/sf-mug-2.jpg",
    clothing: false,
  },
  {
    id: 351,
    title: "Spy x Family: Anya and Bond T-Shirt",
    price: 30,
    image: "/images/merch/Other/sf-shirt.jpg",
    clothing: true,
  },
  {
    id: 352,
    title: "Spy x Family: Forger Family Car T-Shirt",
    price: 30,
    image: "/images/merch/Other/sf-shirt-2.jpg",
    clothing: true,
  },
  {
    id: 353,
    title: "Spy x Family: Anya Heh T-Shirt",
    price: 30,
    image: "/images/merch/Other/sf-shirt-3.jpg",
    clothing: true,
  },
  {
    id: 354,
    title: "Spy x Family: Forger Family T-Shirt",
    price: 30,
    image: "/images/merch/Other/sf-shirt-4.jpg",
    clothing: true,
  },
  {
    id: 355,
    title: "Spy x Family: Anya Forger T-Shirt",
    price: 30,
    image: "/images/merch/Other/sf-shirt-5.jpg",
    clothing: true,
  },
];
